var account = "Konto";
var accountSettings = "Ustawienia konta";
var charging = "Ładowanie";
var contactInfo = "Informacje kontaktowe";
var dashboard = "Pulpit nawigacyjny";
var home = "Strona Główna";
var myProducts = "Moje produkty";
var orderHistory = "Historia zamówień";
var paymentMethod = "Sposób płatności";
var profileSettings = "Ustawienia profilu";
var referAndEarn = "Polecaj i zarabiaj";
var signOut = "Wyloguj się";
var pl_PL = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, pl_PL as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
